<div class="flex items-center">
    <span class="status-circle" [ngClass]="getStatusClass(formControl.value)"></span>
    <span class="text-xs font-bold">{{ getStatusText(formControl.value) }}</span>
</div>
